import React from "react";
import styled from "styled-components/macro";
import Pagination from "@material-ui/lab/Pagination";
import { selectPage, selectTotalPages, setPage } from "./paginationSlice";
import { useDispatch, useSelector } from "react-redux";
import { colors } from "theme/Theme";

interface PaginationProps {
  disabled?: boolean;
}

const SCROLL_TOP_DURATION = 650;
let scrollAnimationFrame: number | undefined;

const getScrollOffset = () =>
  Math.max(
    window.pageYOffset,
    document.documentElement.scrollTop,
    document.body.scrollTop
  );

const scrollPageToTop = () => {
  const prefersReducedMotion =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (scrollAnimationFrame !== undefined) {
    window.cancelAnimationFrame(scrollAnimationFrame);
    scrollAnimationFrame = undefined;
  }

  const initialOffset = getScrollOffset();
  if (prefersReducedMotion || initialOffset <= 1) {
    window.scrollTo(0, 0);
    return;
  }

  let startTime: number | undefined;
  let previousEasedProgress = 0;
  const animateScroll = (timestamp: number) => {
    if (startTime === undefined) {
      startTime = timestamp;
    }

    const progress = Math.min(
      (timestamp - startTime) / SCROLL_TOP_DURATION,
      1
    );
    const easedProgress = 1 - Math.pow(1 - progress, 3);
    const remainingProgress = 1 - previousEasedProgress;
    const frameProgress =
      remainingProgress > 0
        ? (easedProgress - previousEasedProgress) / remainingProgress
        : 1;
    const nextOffset = Math.round(getScrollOffset() * (1 - frameProgress));
    previousEasedProgress = easedProgress;

    window.scrollTo(0, nextOffset);

    if (progress < 1) {
      scrollAnimationFrame = window.requestAnimationFrame(animateScroll);
    } else {
      scrollAnimationFrame = undefined;
    }
  };

  scrollAnimationFrame = window.requestAnimationFrame(animateScroll);
};

//http://localhost:3000/category?type=Инвертор

const PaginationComponent: React.FC<PaginationProps> = ({
  disabled = false,
}) => {
  const dispatch = useDispatch();
  const totalPages = useSelector(selectTotalPages);
  const page = useSelector(selectPage);
  const queryParams = new URLSearchParams(window.location.search);

  const handleOnChange = (ev: React.ChangeEvent<unknown>, value: number) => {
    if (window.location.href.includes("page")) {
      const pageNumber = queryParams.get("page");
      window.history.pushState(
        null,
        "Категория",
        window.location.href.replace(`page=${pageNumber ?? 1}`, `page=${value}`)
      );
    } else {
      window.history.pushState(
        null,
        "Категория",
        `${window.location.href}?page=${value}`
      );
    }

    scrollPageToTop();
    dispatch(setPage(value));
  };

  return (
    <StyledPagination
      count={totalPages}
      page={page}
      onChange={handleOnChange}
      disabled={disabled}
      variant="outlined"
      size="large"
    />
  );
};

const StyledPagination = styled(Pagination)`
  margin-top: 60px;

  .MuiPaginationItem-page.Mui-selected,
  .MuiPaginationItem-page.Mui-selected:hover {
    border: 1px solid ${colors.lighter_blue};
    background-color: ${colors.light_blue};
    color: white;
  }
`;

export default PaginationComponent;
